import { useState } from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { deleteHttp } from "@common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IRemoveEntityDialog } from "./RemoveEntityDialog";

export function useRemoveEntityDialog(props: IRemoveEntityDialog) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const [deleteRiskAssessments, setDeleteRiskAssessments] = useState(false);

    const removeMutation = useDotLegalMutation(
        () =>
            deleteHttp(`/risk-areas/${props.riskAreaId}/entities/${props.entity.type}/${props.entity.entityId}?deleteRiskAssessments=${deleteRiskAssessments}`),
        {
            onSuccess: () => {
                snackbar.show(translateString("entityRemoved"));
                props.onRemoved();
                props.onClose();
            },
        }
    );

    const removeEntity = () => {
        removeMutation.mutateAsync();
    };

    return {
        removeEntity,
        deleteRiskAssessments,
        setDeleteRiskAssessments,
        inProgress: removeMutation.isLoading,
    };
}
